"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldSet = exports.FieldSetDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var section_1 = require("../elements/section");
var use_lang_1 = require("../../hooks/use-lang");
exports.FieldSetDefaultProps = {};
// -------- Styles --------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding-top: 0;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding-top: 0;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FormNameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 0.9em;\n  "], ["\n    font-size: 0.9em;\n  "])))
});
var SetNameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: 0.75em;\n  "], ["\n    font-weight: 400;\n    font-size: 0.75em;\n  "])))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0px 4px ", ";\n    line-height: 1.65em;\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    padding: 0px 4px ", ";\n    line-height: 1.65em;\n    color: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(8), theme_1.theme.COLOR('text-mid'), theme_1.theme.FONT_SIZE(14)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    line-height: 1.75em;\n    font-size: ", ";\n  "], ["\n    line-height: 1.75em;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15)),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(16))
});
var OutroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IntroStyles)
});
// -------- Components --------->
var My = {
  Container: (0, styled_components_1.default)(section_1.Section)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Intro: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Outro: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  FormName: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FormNameStyles),
  SetName: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SetNameStyles)
};
var FieldSet = function (props) {
  var className = props.className,
    label = props.label,
    intro = props.intro,
    outro = props.outro,
    children = props.children,
    paginate = props.paginate,
    formLabel = props.formLabel;
  var t = (0, use_lang_1.useLang)();
  var title = paginate && formLabel ? React.createElement(React.Fragment, null, React.createElement(My.FormName, null, formLabel), React.createElement(My.SetName, null, " - ", label)) : label;
  return paginate ? React.createElement(React.Fragment, null, intro && React.createElement(My.Intro, null, t(intro)), outro && React.createElement(My.Outro, null, t(outro)), children) : React.createElement(My.Container, {
    space: "none",
    className: className,
    title: title
  }, React.createElement(My.Body, null, intro && React.createElement(My.Intro, null, t(intro)), outro && React.createElement(My.Outro, null, t(outro)), children));
};
exports.FieldSet = FieldSet;
exports.FieldSet.defaultProps = exports.FieldSetDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;